<template>
  <div class="container"></div>
</template>
<script>
export default {
  name: "expired",
  created() {
    

    this.$router.push({ path: "/login", params: { expired: 'S'} });
  }
};
</script>
<style>
</style>

